export enum ReportGroupByEnum {
  order = 'orderCode',
  jobSite = 'jobsite',
  customer = 'customerCode',
  pointOfDelivery = 'pointOfDeliveryCode',
}
